import { ParentContext } from "global/cnr/contexts/ParentContext";
import { gEnums } from "global/enums/globalEnums";
import { useContext, useEffect, useMemo, useState } from "react";
import { SeasonMatchesContext } from "../cnr/contexts/SeasonMatchesContext";
import { _matchDisplayTypes } from "../elements/matches/MatchContent";

export const useMatchScheduleOptions = (props) => {

  const msdts = gEnums.matchScheduleDisplayTypes

  const {
    matchScheduleDisplayType,
  } = props;

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state } = seasonMatchesContext ?? {}
  const { matchFilter } = seasonMatches_state ?? {}

  const [matchScheduleOptions, setMatchScheduleOptions] = useState({})

  let _matchScheduleDisplayType = matchScheduleDisplayType ? matchScheduleDisplayType : msdts.clickedDates

  const _matchDisplayType = useMemo(() => {
    switch (_matchScheduleDisplayType) {
      case msdts.levelDates:
      case msdts.levelDates:
      case msdts.levelSelectedDate:
      case msdts.levelTabsDates:
      case msdts.levelTabsFull:
      case msdts.currentMatches:
      case msdts.missing:
      case msdts.matchDay:
      case msdts.pendingMatches:
        return _matchDisplayTypes.levelMatches;

      case msdts.scoreboard:
        return _matchDisplayTypes.scoreboard;

      case msdts.teamSchedule:
      case msdts.teamScheduleRemaining:
      case msdts.nextTeamMatch:
      case msdts.direct:
      case msdts.teamsCommon:
        return _matchDisplayTypes.teamMatches;

      case msdts.latestMatches:
        return _matchDisplayTypes.levelOverviewMatches
      default:
      // nothing
    }
  }, [_matchScheduleDisplayType, matchFilter]);


  useEffect(() => {

    const _matchDisplayOptions = {
      showDataHeader: false,
      showLevelHeader: false,
      showMatchFilter: false,
      showCalendar: false,
      showGotoToday: false,
      showScheduleHeader: false,
      showLegend: false,
      showDateList: false,
      showMatchChanges: true,
      showMatchHeader: false,
    }

    switch (_matchScheduleDisplayType) {
      case msdts.scoreboard:
        _matchDisplayOptions.showDataHeader = true
        break;
      default:
      // nothing
    }

    switch (_matchScheduleDisplayType) {
      case msdts.levelTabsFull:
        _matchDisplayOptions.showLegend = true
        _matchDisplayOptions.showMatchHeader = true
        _matchDisplayOptions.showGotoToday = true
        break;
      default:
      // nothing
    }

    switch (_matchScheduleDisplayType) {
      case msdts.missing:
      case msdts.currentMatches:
      case msdts.levelTabsFull:
      case msdts.scoreboard:
      case msdts.matchDay:
        _matchDisplayOptions.showLevelHeader = true
        _matchDisplayOptions.showScheduleHeader = true
        break;
      case msdts.teamSchedule:
        _matchDisplayOptions.showMatchFilter = true
        break;
      default:
      // nothing
    }

    switch (_matchScheduleDisplayType) {
      case msdts.currentMatches:
        _matchDisplayOptions.showMatchChanges = true
        break;
        break;
      default:
      // nothing
    }

    const _matchScheduleInfo = {
      _matchDisplayType,
      _matchDisplayOptions,
    }
    setMatchScheduleOptions(_matchScheduleInfo)
  }, [_matchScheduleDisplayType]);

  return matchScheduleOptions

};